module.exports = __webpack_public_path__ + "../../img/swarm-logo.3a0ba593.png";